import React from 'react';
import { observer } from 'mobx-react';
import { WarehouseEditTemplate } from 'themes/modules/warehouse/pages';
import { WarehouseEditViewStore } from 'modules/warehouse/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new WarehouseEditViewStore(rootStore), 'warehouseEditViewStore')
@observer
class WarehouseEdit extends React.Component {
	render() {
		return <WarehouseEditTemplate {...this.props} />;
	}
}

export default WarehouseEdit;
